import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleAuthorDetailsContent$key } from "~/queries/__generated__/articleAuthorDetailsContent.graphql";

import { AuthorCard } from "./author-card";
import { AuthorCardsContainer } from "./styles";

export type Props = {
  reference: articleAuthorDetailsContent$key;
};

export const ArticleAuthorsDetails: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const content = useFragment(
    graphql`
      fragment articleAuthorDetailsContent on Content {
        authors {
          entityId
          ...authorCardAuthor
          bio
        }
      }
    `,
    reference_,
  );

  const validAuthors = content.authors?.filter(author => author?.bio) ?? [];
  const validAuthorsLength = validAuthors?.length ?? 0;
  if (!content || validAuthorsLength === 0) return null;
  return (
    <AuthorCardsContainer>
      {content.authors
        ?.filter(author => author?.bio)
        .map(author => author && <AuthorCard key={author.entityId} reference={author} />)}
    </AuthorCardsContainer>
  );
};

ArticleAuthorsDetails.displayName = "ArticleAuthorsDetails";
